import { createElement } from "react";

import useRemove from "@/hooks/use-remove";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { userService } from "@/services/user.service";

export type UseRemoveUserReturn = {
  removeUser: (props: {
    id: number;
    successMessage?: string;
    errorMessage?: string;
    onSuccess?: () => void;
    onError?: () => void;
  }) => Promise<void>;
} & UseLoadingReturn;

const useRemoveUser = (): UseRemoveUserReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: async (_id: number) => {
      await userService.delete(_id);
    },
  });

  const removeUser = async ({
    id,
    successMessage = "",
    errorMessage = "",
    onSuccess,
    onError,
  }: {
    id: number;
    successMessage?: string;
    errorMessage?: string;
    onSuccess?: () => void;
    onError?: () => void;
  }) => {
    await remove({ _id: id, successMessage, errorMessage, onSuccess, onError });
  };

  return { isLoading, startLoading, endLoading, loadingIcon, removeUser };
};

export default useRemoveUser;
